(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", (e) => {
  //GESTIONE DI TUTTE LE PATCH PER L'APP FATTURE ITALIA
  window.MayerMoover_custom.sistemazioneFattureItalia(loc, '#checkout');

});

  } catch(e) { console.error(e); }
})();
})();
